module.exports = __webpack_public_path__ + "media/images/mobile-only/background-05c9d508911a4407d53f626e391008ca.jpg";